const responsive = {
  landscape: {
    width: 1448,
    height: 848,
  },
  portrait: {
    width: 1080,
    height: 1448,
  },
};

enum TEXT_MENU {
  card = 'card',
  random = 'random',
  flame = 'flame',
  back = 'back',
}

export { TEXT_MENU, responsive };
